import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface NavigationProps {
  onLogout: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onLogout }) => {
  const { user } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="sidebar-navigation">
      <div className="sidebar-header">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img
            src="/nib-logo-white.webp"
            alt="NIB Logo"
            style={{ height: "40px", width: "auto" }}
          />
        </div>
        <div
          style={{
            fontSize: "0.75rem",
            color: "rgba(255, 255, 255, 0.7)",
            marginTop: "4px",
          }}
        ></div>
      </div>

      <div className="sidebar-user-info">
        <div className="user-main">
          <span className="user-email">{user?.email}</span>
          {user?.role && (
            <span className={`user-role ${user.role}`}>
              {user.role.toUpperCase()}
            </span>
          )}
        </div>
        {user?.branch_id && (
          <span className="user-branch">Branch: {user.branch_id}</span>
        )}
      </div>

      <div className="sidebar-nav-links">
        <Link
          to="/dashboard"
          className={`nav-link ${isActive("/dashboard") ? "active" : ""}`}
        >
          Dashboard
        </Link>
        <Link
          to="/links"
          className={`nav-link ${isActive("/links") ? "active" : ""}`}
        >
          Links
        </Link>
        <Link
          to="/verifications"
          className={`nav-link ${isActive("/verifications") ? "active" : ""}`}
        >
          Verifications
        </Link>
        {user?.role === "admin" && (
          <Link
            to="/dashboard/users"
            className={`nav-link ${
              isActive("/dashboard/users") ? "active" : ""
            }`}
          >
            User Management
          </Link>
        )}
      </div>

      <div className="sidebar-footer">
        <a
          href="#"
          className="nav-link logout-link"
          onClick={(e) => {
            e.preventDefault();
            onLogout();
          }}
        >
          Logout
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
